<template>
  <div class="main-page page-agency ">
    <Menu title="司法鉴定" :home="true"></Menu>
    <div class="main-block">
      <div class="wrap">
        <div class="left-nav">
          <div :class="['item','txtone',index==current?'active':'']" v-for="(navitem ,index) in identifytree" @click="getNavData(navitem,index)" :key="'key-nav'+index">
            {{navitem.name}}
          </div>
        </div>
        <div class="right-con noscroll" v-if="currentData">
          <div class="item">
            <div class="item-title">
              {{currentData.name}}
            </div>
            <div class="tag-list" v-for="(list,index) in currentData.children" :key="'key-dd'+index" v-if="!currentData.thrlevel">
              <div class="tag-title" v-if="list.name">
                {{list.name}}
              </div>
              <div class="tag-box">
                <div class="tag-item" @click="getType(tag)" v-for="(tag,index) in list.children" :key="'key-'+index">
                  {{tag.name}}
                </div>
              </div>
            </div>
            <div class="tag-list" v-if="currentData.thrlevel">
              <div class="tag-box">
                <div class="tag-item" @click="getType(tag)" v-for="(tag,index) in currentData.children" :key="'key-'+index">
                  {{tag.name}}
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <AgencySlide v-if="slide.show" :slide="slide" @updatedoffice="getJdoffice" :jdofficelist="jdofficelist" @getClose="getClose"></AgencySlide>
  </div>
</template>
<script>
import Menu from '../../components/Menu'
import AgencySlide from './AgencySlide'
import api from '../../datas/js/api.js'
import { IDENTIFICATION_ORGAN } from '../../datas/constants/statistics'
export default {
  components: {
    Menu,
    AgencySlide
  },
  data () {
    return {
      identifytree: [],
      current: 0,
      slide: {
        show: false,
        currentTypeId: '',
        currentTypeName: '',

      },
      currentareacode: 0,
      jdofficelist: []
    }
  },
  computed: {
    currentData () {
      return this.identifytree.length ? this.identifytree[this.current] : ''
    }
  },
  async mounted () {
    this.getTreeData()
    const StateDevice = this.$store.state.device
    this.currentarea = StateDevice.config.web_area
    this.currentareacode = StateDevice.config.web_code
    this.$root.getStatistics(IDENTIFICATION_ORGAN)
  },
  methods: {
    async getTreeData () {
      const result = await this.$api.getIdentifyTree()
      if (!result) return
      this.identifytree = result.data.map(v => {
        v.text = v.name
        v.thrlevel = v.children.every(j => !j.children.length)
        v.children.map(j => {
          if (!v.thrlevel && !j.children.length) {
            j.children = [{
              name: j.name,
              code: j.code,
              id: j.id,
              children: []
            }]
          }
          return j
        })
        return v
      })
    },
    getClose () {
      this.slide.show = false
    },
    getNavData (item, index) {
      this.current = index
    },
    async getType (item) {
      this.slide.currentTypeId = item.id
      this.slide.currentTypeName = item.name
      await this.getJdoffice(this.currentareacode)
      this.slide.show = true
    },
    async getJdoffice (code) {
      this.$loading.show()
      let data = await this.$get(
        api.jiandingoffice + code + '&business_type=' + this.slide.currentTypeId
      )
      this.jdofficelist = data.result.data
      this.$loading.hide()
    }
  }
}
</script>

<style lang="stylus">
.page-agency
  .main-block
    flex 1
    overflow hidden
  .wrap
    width 14rem
    height 100%
    margin 0 auto
    padding 0.3rem 0 0
    display flex
    .left-nav
      width 3.2rem
      height 100%
      padding-bottom 0.25rem
      margin-right 0.4rem
      overflow-y scroll
      -webkit-overflow-scrolling touch
      &::-webkit-scrollbar
        display none
        width 0 !important
      .item
        height 0.8rem
        line-height 0.8rem
        font-size 0.26rem
        color rgba(255, 255, 255, 0.9)
        padding 0 0.35rem
        background-color rgba(255, 255, 255, 0.2)
        border-radius 0.08rem
        border solid 1px rgba(255, 255, 255, 0.2)
        margin-bottom 0.05rem
        &.active
          background #f29530
  .right-con
    width 10rem
    height 100%
    overflow-y scroll
    .item
      background-color #ffffff
      border-radius 0.1rem
      margin-bottom 0.3rem
      padding-bottom 0.4rem
      .item-title
        height 0.74rem
        line-height 0.74rem
        border-bottom 1px solid #e5e5e5
        padding-left 0.34rem
        font-weight 600
        margin-bottom 0.3rem
      .tag-list
        margin-bottom 0.3rem
      .tag-title
        padding 0 0 0.2rem 0.33rem
        font-size 0.24rem
        line-height 1
        color #333333
      .tag-box
        display flex
        flex-wrap wrap
        padding 0 0.23rem
        .tag-item
          height 0.6rem
          margin 0 0.1rem 0.2rem 0.1rem
          line-height 0.6rem
          font-size 0.22rem
          background-color #e6eaf2
          border-radius 0.06rem
          padding 0 0.35rem
</style>
